<div class="d-flex content-body-wrapper h-100">
  <div class="d-flex tree-view nav-wrapper flex-column">
    <div class="title header-5 d-flex justify-content-center flex-column">
      Automatic Script Generation
    </div>
    <app-tree-view
      class="w-100 tree-view-section"
      [nodes]="treeData"
      [selectedNode]="selectedItem"
      [hideIconForChildren]="true"
      [singleExpandMode]="true"
      [isloading]="(loading$ | async) ?? false"
      (menuItemSelected)="onMenuItemSelected($event)"
    ></app-tree-view>
    <div *ngIf="!isFrameworkTypeLoading"
      class="config-panel d-flex cursor-pointer"
      (click)="openConfiguration()"
      (keydown)="openConfiguration()"
    >
      <img
        class="logo m-auto"
        [src]="'images/virtusa-icons/cogwheel.svg' | assetUrl"
        alt="Icon"
      />
      <span class="m-auto config-panel-container header-8">
        Configuration
      </span>
    </div>
  </div>
  <div class="d-flex flex-grow-1 flex-column">
    <div class="content-header d-flex">
      <div class="breadcrumb d-flex flex-grow-1">
        <div
          class="download-wrapper cursor-pointer"
          (click)="downloadProject()"
          (keydown)="downloadProject()"
        >
          <img
            class="m-auto d-flex download-icon"
            [src]="'images/virtusa-icons/download-img.svg' | assetUrl"
            alt="Icon"
          />
        </div>
      </div>
      <div
        class="d-flex framework-container m-auto"
        *ngIf="!isFrameworkTypeLoading"
      >
        <span class="m-auto general-text-16"> Framework Type: </span>
        @if(selectedFramworkType) {
        <span class="m-auto accello-general-text13 framework-type">
          {{ selectedFramworkType }}
        </span>
        } @else {
        <img
          class="logo m-auto"
          [src]="'images/virtusa-icons/frmework-info.svg' | assetUrl"
          data-toggle="tooltip"
          data-placement="top"
          [title]="
            'Please select a framework type from Settings before configuring other options.'
          "
          alt="Icon"
        />
        }
      </div>
      <div
        class="search-content-wrapper d-flex justify-content-center flex-column"
      >
        <div class="accello-primary-search d-flex mx-auto">
          <input
            type="text"
            placeholder="Search"
            class="search-input-wrapper general-text-5 content-search-color"
          />
          <button class="search-button content-search-color d-flex mx-auto">
            <img
              src="assets/images/virtusa-icons/search-icon.svg"
              class="general-text-5 content-search-color"
              width="12px"
              height="12px"
            />
          </button>
        </div>
      </div>
    </div>
    <div class="content-body d-flex flex-grow-1">
      @if(!selectedItem) {
      <app-script-card-tile
        class="w-100"
        [cardList]="scriptCards"
        [loading]="loading"
        (onActionFireEvents)="
          onActionFireEvents($event.event, $event.actionType, $event.$event)
        "
      ></app-script-card-tile>
      }
      <div class="w-100" [hidden]="!selectedItem">
        <div #appGenericView></div>
      </div>
    </div>
  </div>
</div>
